import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { AdditionalQuestionsObject } from '../definition/interface/Pledge';

export default {
  generatForm(
    entity: AdditionalQuestionsObject,
    formBuilder: UntypedFormBuilder,
  ): UntypedFormGroup {
    let formBuilderGroup = formBuilder.group({
      accountInformations: formBuilder.group({
        investmentHorizon: [
          entity?.accountInformations?.investmentHorizon ||
            'BETWEEN_8_AND_12_YEARS',
        ],
        financialKnowledgeLevel: [
          entity?.accountInformations?.financialKnowledgeLevel || null,
        ],
        frequencyFinancialTransactions: [
          entity?.accountInformations?.frequencyFinancialTransactions || null,
        ],
        numberTransactionsLastYear: [
          entity?.accountInformations?.numberTransactionsLastYear || null,
        ],
        durationBeginInvestment: [
          entity?.accountInformations?.durationBeginInvestment || null,
        ],
        enableContactActuScpi: [
          entity?.accountInformations?.enableContactActuScpi ?? true,
        ],
        enableDematerializationDocuments: [
          entity?.accountInformations?.enableDematerializationDocuments ?? true,
        ], //
        realEstateKnowledgeLevel: [
          entity?.accountInformations?.realEstateKnowledgeLevel || null,
        ],
        hasInvestScpi: [entity?.accountInformations?.hasInvestScpi ?? false],
        amountInvestScpi: [
          entity?.accountInformations?.amountInvestScpi || null,
        ],
        frequencyInvestScpi: [
          entity?.accountInformations?.frequencyInvestScpi || null,
        ],
        numberScpiInvestLastYear: [
          entity?.accountInformations?.numberScpiInvestLastYear || null,
        ],
        hasInvestLifeInsurance: [
          entity?.accountInformations?.hasInvestLifeInsurance ?? false,
        ],
        amountInvestLifeInsurance: [
          entity?.accountInformations?.amountInvestLifeInsurance || null,
        ],
        hasInvestGirardin: [
          entity?.accountInformations?.hasInvestGirardin ?? false,
        ],
        amountInvestGirardin: [
          entity?.accountInformations?.amountInvestGirardin || null,
        ],
        hasInvestCrowdfunding: [
          entity?.accountInformations?.hasInvestCrowdfunding ?? false,
        ],
        amountInvestCrowdfunding: [
          entity?.accountInformations?.amountInvestCrowdfunding ?? null,
        ],
        hasInvestOcpBusinessCenter: [
          entity?.accountInformations?.hasInvestOcpBusinessCenter ?? false,
        ],
        amountInvestOcpBusinessCenter: [
          entity?.accountInformations?.amountInvestOcpBusinessCenter ?? null,
        ],
        hasInvestOcpClubDeal: [
          entity?.accountInformations?.hasInvestOcpClubDeal ?? false,
        ],
        amountInvestOcpClubDeal: [
          entity?.accountInformations?.amountInvestOcpClubDeal ?? null,
        ],
        hasInvestFip: [entity?.accountInformations?.hasInvestFip ?? false],
        amountInvestFip: [entity?.accountInformations?.amountInvestFip ?? null],

        hasInvestFcpi: [entity?.accountInformations?.hasInvestFcpi ?? false],
        amountInvestFcpi: [
          entity?.accountInformations?.amountInvestFcpi ?? null,
        ],
        hasPeaInvestmentSupport: [
          entity?.accountInformations?.hasPeaInvestmentSupport ?? false,
        ],
        liquidity: [entity?.accountInformations?.liquidity || null],
        monthlySaving: [entity?.accountInformations?.monthlySaving || null],
        epargnePrecaution: [
          entity?.accountInformations?.epargnePrecaution || null,
        ],
        investmentGoals: [entity?.accountInformations?.investmentGoals || null],
      }),
    });

    return formBuilderGroup;
  },
};
